import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import "owl.carousel/dist/assets/owl.carousel.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { Dropdown } from "primereact/dropdown";
import { ChevronRightIcon } from "primereact/icons/chevronright";
import { ChevronDownIcon } from "primereact/icons/chevrondown";
import { ThemeContext } from "../../../Services/Context-Api/ThemeContext";
const AccountOwnerPage = () => {
  const [selectedLang, setSelectedLang] = useState([]);
  const [selectedLanguage, satLang] = React.useState("");
  const toster = useContext(TostMsg);
  let SelectedLang = JSON.parse(localStorage.getItem("LanguageKey") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { theme, toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    getLanguage();
  }, []);

  const getLanguage = async () => {
    let params = {
      masterType: "Language",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params);
      setSelectedLang(responce?.Data);
      let setLang = responce?.Data?.filter((el) => el?.Name == SelectedLang);
      satLang(setLang[0]);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  const setSelectedCity = (Lang) => {
    satLang(Lang);
    localStorage.setItem("LanguageKey", JSON.stringify(Lang?.Name));
    window.location.reload();
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="d-flex align-items-center">
          <img
            alt={option.Name}
            src={option.Logo}
            style={{ width: "18px", marginRight: "10px" }}
          />
          <div>{option.Name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };
  const countryOptionTemplate = (option) => {
    return (
      <div
        className="flex align-items-center"
        style={{ display: "flex", marginLeft: "19px" }}
      >
        <img
          alt={option?.Name}
          src={option?.Logo}
          style={{ width: "18px", marginRight: "9px" }}
        />
        <div>{option?.Name}</div>
      </div>
    );
  };
  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Setting</h2>
            </div>
          </div>
          <div className="account-owner mt-4 mb-4">
            <ul className="nav nav-tabs firstnav-own">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#home"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-gear"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                  </svg>
                  Account Defaults
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#GenericSettings"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-lock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
                  </svg>
                  Generic Settings
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-lock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
                  </svg>
                  Access Levels
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-ui-checks-grid"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z" />
                  </svg>
                  Employee Fields
                </a>
              </li> */}
              {/* <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-hand-thumbs-up"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                  </svg>
                  Approvals
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-app-indicator"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
                    <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  </svg>
                  Apps
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-balloon-heart"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="m8 2.42-.717-.737c-1.13-1.161-3.243-.777-4.01.72-.35.685-.451 1.707.236 3.062C4.16 6.753 5.52 8.32 8 10.042c2.479-1.723 3.839-3.29 4.491-4.577.687-1.355.587-2.377.236-3.061-.767-1.498-2.88-1.882-4.01-.721L8 2.42Zm-.49 8.5c-10.78-7.44-3-13.155.359-10.063.045.041.089.084.132.129.043-.045.087-.088.132-.129 3.36-3.092 11.137 2.624.357 10.063l.235.468a.25.25 0 1 1-.448.224l-.008-.017c.008.11.02.202.037.29.054.27.161.488.419 1.003.288.578.235 1.15.076 1.629-.157.469-.422.867-.588 1.115l-.004.007a.25.25 0 1 1-.416-.278c.168-.252.4-.6.533-1.003.133-.396.163-.824-.049-1.246l-.013-.028c-.24-.48-.38-.758-.448-1.102a3.177 3.177 0 0 1-.052-.45l-.04.08a.25.25 0 1 1-.447-.224l.235-.468ZM6.013 2.06c-.649-.18-1.483.083-1.85.798-.131.258-.245.689-.08 1.335.063.244.414.198.487-.043.21-.697.627-1.447 1.359-1.692.217-.073.304-.337.084-.398Z"
                    />
                  </svg>
                  Benefits Fields
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-vcard"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" />
                    <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12V4Z" />
                  </svg>
                  Company Directory
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-lock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
                  </svg>
                  Access Levels
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-ui-checks-grid"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z" />
                  </svg>
                  Employee Fields
                </a>
              </li> */}
              {/* <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-hand-thumbs-up"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                  </svg>
                  Approvals
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-app-indicator"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
                    <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  </svg>
                  Apps
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-balloon-heart"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="m8 2.42-.717-.737c-1.13-1.161-3.243-.777-4.01.72-.35.685-.451 1.707.236 3.062C4.16 6.753 5.52 8.32 8 10.042c2.479-1.723 3.839-3.29 4.491-4.577.687-1.355.587-2.377.236-3.061-.767-1.498-2.88-1.882-4.01-.721L8 2.42Zm-.49 8.5c-10.78-7.44-3-13.155.359-10.063.045.041.089.084.132.129.043-.045.087-.088.132-.129 3.36-3.092 11.137 2.624.357 10.063l.235.468a.25.25 0 1 1-.448.224l-.008-.017c.008.11.02.202.037.29.054.27.161.488.419 1.003.288.578.235 1.15.076 1.629-.157.469-.422.867-.588 1.115l-.004.007a.25.25 0 1 1-.416-.278c.168-.252.4-.6.533-1.003.133-.396.163-.824-.049-1.246l-.013-.028c-.24-.48-.38-.758-.448-1.102a3.177 3.177 0 0 1-.052-.45l-.04.08a.25.25 0 1 1-.447-.224l.235-.468ZM6.013 2.06c-.649-.18-1.483.083-1.85.798-.131.258-.245.689-.08 1.335.063.244.414.198.487-.043.21-.697.627-1.447 1.359-1.692.217-.073.304-.337.084-.398Z"
                    />
                  </svg>
                  Benefits Fields
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-vcard"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" />
                    <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12V4Z" />
                  </svg>
                  Company Directory
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#menu2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-envelope-exclamation"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
                  </svg>
                  Email Alerts
                </a>
              </li> */}
            </ul>

            <div className="tab-content main-tab-content">
              <div className="tab-pane container active mt-0 p-0" id="home">
                <div className="p-4">
                  <strong>Account Defaults</strong>
                  <ul className="nav nav-tabs d-flex">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#o-home"
                      >
                        General
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#company-info"
                      >
                        Company Info
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#branding"
                      >
                        Branding
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#transaction"
                      >
                        Transaction
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu1"
                      >
                        Rewards
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu2"
                      >
                        Kudos
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#delete-account"
                      >
                        Delete Account
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane container active mt-0 p-2"
                      id="o-home"
                    >
                      <div className="acc-summary">
                        <div className="inner-acc-summary">
                          <strong className="owner-name">Arun Mishre</strong>
                          <p className="m-0 accountown">Account Owner</p>
                        </div>
                        <img
                          src="images/icon.png"
                          className="logo-abbr ml-auto"
                        />
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <span>Company Name</span>
                          <input
                            className="form-control"
                            value={"BizBrolly - Get IT Right"}
                          />
                        </div>
                        <div className="col-6">
                          <span>Your BambooHR URL</span>
                          <input
                            className="form-control"
                            value={"bizbrollysolutionspvtltd.bamboohr.com"}
                          />
                        </div>
                        <div className="col-6">
                          <span>Active Employees</span>
                          <input className="form-control" value={"45"} />
                        </div>
                        <div className="col-6">
                          <span>Data Center Location</span>
                          <input className="form-control" value={"India"} />
                        </div>
                        <div className="col-6">
                          <span>Data Center Location</span>
                          <input className="form-control" value={"India"} />
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="company-info"
                    >
                      <div className="acc-title">
                        <span className="heading">Points of Contact</span>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="inner">
                            <strong>Primary Account Contact</strong>
                            <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing
                              elit. Ut eos necessitatibus doloremque rem? Illum
                              totam omnis reiciendis ab quae est dolores iure
                              perferendis asperiores, cupiditate nemo quis
                              voluptatem, quod mollitia?
                            </p>
                            <div className="form-group">
                              <label>Select User*</label>
                              <select className="form-control">
                                <option>
                                  Arun Mishra (hello@bizbrolly.com)
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="inner">
                            <strong>Billing Contact</strong>
                            <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing
                              elit. Ut eos necessitatibus doloremque rem? Illum
                              totam omnis reiciendis ab quae est dolores iure
                              perferendis asperiores, cupiditate nemo quis
                              voluptatem, quod mollitia?
                            </p>
                            <div className="form-group">
                              <select className="form-control">
                                <option>
                                  Arun Mishra (hello@bizbrolly.com)
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="branding"
                    >
                      <div className="brand-account">
                        <div className="inner-acc-summary">
                          <strong className="deletacc">Branding</strong>
                          <p className="m-0 accountown">
                            Set your logo and color of your tools wher you can
                            show your branding. These settings will help you
                            quickly choose brand options when creating public
                            facing content.
                          </p>
                        </div>
                      </div>
                      <div className="setbrand">
                        {/* <img src="images/icon.png"/> */}
                        <p className="icon">BB</p>
                        <strong className="deletacc">My Brand Kit</strong>
                        <span>Primary</span>
                        <button>Edit</button>
                      </div>
                    </div>
                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="transaction"
                    >
                      <div className="brand-account">
                        <div className="inner-acc-summary">
                          <strong className="deletacc">Transaction</strong>
                          <p className="m-0 accountown">
                            Your transaction history will be here.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="o-menu1"
                    >
                      <div className="row mt-2">
                        <div className="form-head d-flex flex-wrap add-rewardslide mb-2">
                          <div className="me-auto mb-3">
                            <strong className="deletacc">Rewards</strong>
                          </div>
                          <div className="form-head">
                            <div className="input-group search-area2 d-xl-inline-flex me-2">
                              <button className="input-group-text">
                                <i className="fa fa-search text-primary"></i>
                              </button>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search here..."
                              />
                            </div>
                          </div>
                          <div className="form-head mr-3">
                            <button className="filter-awards" id="filterbtnn">
                              <i
                                aria-hidden="true"
                                className="fa fa-filter"
                              ></i>
                            </button>
                          </div>
                          <div className="form-head">
                            <button
                              className="filter-awards"
                              id="add-rewardicon"
                            >
                              <i
                                aria-hidden="true"
                                className="fa fa-plus-square-o"
                              ></i>
                            </button>
                          </div>
                          <div
                            className="filter-div"
                            style={{ display: "none" }}
                          >
                            <span className="tagline-filter">Filter</span>
                            <div className="row g-2 align-items-end">
                              <div className="col-md-4">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  Name
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  Award Category
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  When(Date)
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>

                              <div className="col-md-2">
                                <button className="add-btncss">
                                  {T("Apply")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className="add-rewardform"
                            style={{ display: "none" }}
                          >
                            <span className="tagline-filter">Add Reward</span>
                            <div className="row g-2 align-items-end">
                              <div className="col-md-4">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  Name
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  Award Category
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-3">
                                <label
                                  className="col-form-label"
                                  htmlFor="validationCustom05"
                                >
                                  When(Date)
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                />
                              </div>

                              <div className="col-md-2">
                                <button className="add-btncss">
                                  {T("Apply")}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="employee-card tile-grid tile-grid-v1">
                          <div className="table-responsive">
                            <table
                              id="example"
                              className="table table-striped table-bordered"
                              style={{ width: "100%" }}
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "10px" }}>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="checkAll"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="checkAll"
                                      ></label>
                                    </div>
                                  </th>
                                  <th>Name</th>
                                  <th>Email Id</th>
                                  <th>Phone</th>
                                  <th>Category</th>
                                  <th>When</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/6.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>System Architect</td>
                                  <td>Edinburgh</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2011-04-25</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/8.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Sonal
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Accountant</td>
                                  <td>Tokyo</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/2.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2011-07-25</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/1.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Anubhav Singh
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Junior Technical Author</td>
                                  <td>San Francisco</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/2.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2009-01-12</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>

                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/2.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Dharmesh tyagi
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Senior Javascript Developer</td>
                                  <td>Edinburgh</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/2.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2012-03-29</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/3.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Rashika
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Accountant</td>
                                  <td>Tokyo</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2008-11-28</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/4.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Arun Mishra
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Integration Specialist</td>
                                  <td>New York</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/2.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2012-12-02</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/5.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Ambika
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Sales Assistant</td>
                                  <td>San Francisco</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2012-08-06</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/6.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Ravi Bhandari
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Integration Specialist</td>
                                  <td>Tokyo</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2010-10-14</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/7.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Darshita
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Javascript Developer</td>
                                  <td>San Francisco</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2009-09-15</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/8.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Sanjeev
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Software Engineer</td>
                                  <td>Edinburgh</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2008-12-13</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/1.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Geeta Verma
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Office Manager</td>
                                  <td>London</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2008-12-19</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/6.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Savita
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Support Lead</td>
                                  <td>Edinburgh</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2013-03-03</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="form-check custom-checkbox checkbox-success check-lg">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckBox2"
                                        required=""
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customCheckBox2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <a href="profile-personalinfo.html">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/avatar/2.jpg"
                                          className="rounded-lg me-2"
                                          width="24"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Payal
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>Regional Director</td>
                                  <td>San Francisco</td>
                                  <td>
                                    <a href="/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="images/org-img/awards/1.png"
                                          className="me-2"
                                          width="15"
                                          alt=""
                                        />{" "}
                                        <span className="w-space-no">
                                          Jackson
                                        </span>
                                      </div>
                                    </a>
                                  </td>
                                  <td>2008-10-16</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        href="/"
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </a>
                                      <a
                                        href="/"
                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="o-menu2"
                    >
                      <div className="row mt-2">
                        <div className="form-head d-flex flex-wrap align-items-center">
                          <div className="me-auto mb-3">
                            <strong className="deletacc">Kudos</strong>
                          </div>
                        </div>
                        <div className="kudos-list mt-4">
                          <ul>
                            <li>
                              <p>
                                Reference site about Lorem Ipsum, giving
                                information on its origins, as well as a random
                                Lipsum generator.
                              </p>
                              <div className="basic-form mx-3">
                                <label className="switch112 ">
                                  <input type="checkbox" />
                                  <span>
                                    <em></em>
                                    <strong></strong>
                                  </span>
                                </label>
                              </div>
                            </li>
                            <li>
                              <p>
                                Reference site about Lorem Ipsum, giving
                                information on its origins, as well as a random
                                Lipsum generatorference site about Lorem Ipsum,
                                giving information on its origins, as well as a
                                random Lipsum generator.
                              </p>
                              <div className="basic-form mx-3">
                                <label className="switch112 ">
                                  <input type="checkbox" />
                                  <span>
                                    <em></em>
                                    <strong></strong>
                                  </span>
                                </label>
                              </div>
                            </li>
                            <li>
                              <p>Reference site about Lorem .</p>
                              <div className="basic-form mx-3">
                                <label className="switch112 ">
                                  <input type="checkbox" />
                                  <span>
                                    <em></em>
                                    <strong></strong>
                                  </span>
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane container fade mt-0 p-2"
                      id="delete-account"
                    >
                      <div className="delete-account">
                        <div className="inner-acc-summary">
                          <strong className="deletacc">
                            Delete your HubSpot Account
                          </strong>
                          <p className="m-0 accountown">
                            Delete this account HubSpot ID (45465#) and
                            everything associate wit it.
                          </p>
                        </div>
                        <button>Delete account</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane container fade mt-0 p-0"
                id="GenericSettings"
              >
                <div className="d-flex">
                  <ul className="nav nav-tabs flex-column p-4">
                    <li className="heading-li">Generic Settings</li>
                    <li>
                      <p>Dark Themes</p>
                      <div className="basic-form mx-3">
                        <div className="theme-mode">
                          <div
                            className={`form-check form-switch text-${
                              theme === "light" ? "Dark" : "Light"
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                              onClick={toggleTheme}
                            />
                            {/* <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Mode</label> */}
                          </div>
                          {/* <button onClick={toggleTheme}>
                  Toggle to {theme === "light" ? "Dark" : "Light"} Mode
                </button> */}
                        </div>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link">Change Language</a>
                      <div className="lang-li">
                        <Dropdown
                          value={selectedLanguage}
                          onChange={(e) => setSelectedCity(e.value)}
                          options={selectedLang}
                          optionLabel="Name"
                          placeholder="Select a Country"
                          valueTemplate={selectedCountryTemplate}
                          itemTemplate={countryOptionTemplate}
                          className="w-full md:w-14rem"
                          dropdownIcon={(opts) => {
                            return opts.iconProps["data-pr-overlay-visible"] ? (
                              <ChevronRightIcon {...opts.iconProps} />
                            ) : (
                              <ChevronDownIcon {...opts.iconProps} />
                            );
                          }}
                        />
                      </div>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane container active mt-0 p-3"
                      id="o-home"
                    >
                      {" "}
                      chdzdhch
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu1"
                    >
                      kshkhsdjh
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu2"
                    >
                      chksjckjkj
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="tab-pane container fade mt-0 p-0" id="menu1">
                <div className="d-flex">
                  <ul className="nav nav-tabs flex-column p-4">
                    <li className="heading-li">Access Levels</li>
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#o-home"
                      >
                        Account
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu1"
                      >
                        Access Levels
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu2"
                      >
                        Employee Fields
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane container active mt-0 p-3"
                      id="o-home"
                    >
                      {" "}
                      chdzdhch
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu1"
                    >
                      kshkhsdjh
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu2"
                    >
                      chksjckjkj
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="tab-pane container fade mt-0 p-0" id="menu2">
                <div className="d-flex">
                  <ul className="nav nav-tabs flex-column">
                    <li className="heading-li">Employee Fields</li>
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#o-home"
                      >
                        Account
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu1"
                      >
                        Access Levels
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#o-menu2"
                      >
                        Employee Fields
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane container active mt-0 p-3"
                      id="o-home"
                    >
                      {" "}
                      chdzdhch
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu1"
                    >
                      kshkhsdjh
                    </div>

                    <div
                      className="tab-pane container fade mt-0 p-3"
                      id="o-menu2"
                    >
                      chksjckjkj
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountOwnerPage;
